import { apiClient } from './client'

export interface PlatformDependency {
  feature: string
  why: string
}
export interface CatalogueProperty {
  name: string
  type: string
  description: string
  unique: boolean
  required: boolean
  is_display_name: boolean
  is_temporal_anchor: boolean
  platform_bound: PlatformDependency | null
}
export interface CatalogueType {
  label: string
  description: string
  domains: string[]
  properties: CatalogueProperty[]
  platform_bound: PlatformDependency | null
}
export interface SchemaCatalogue {
  version: number
  domains: { id: string; title: string; description: string }[]
  entities: CatalogueType[]
  relationships: CatalogueType[]
  patterns: {
    source: string
    relationship: string
    target: string
    domains: string[]
    description: string
  }[]
}
export const getSchemaCatalogue = () => apiClient.get<SchemaCatalogue>('/v1/schemas/catalogue')
